import { Combobox, ComboboxOptionText, useComboboxContext, useComboboxOptionContext } from '@reach/combobox';
import { LegacyBasicCombobox as LegacyBasicCombobox$1 } from './legacy.basic-combobox.component.js';
import { deprecatedComponent } from '../../../react/components/core/deprecated-component.js';

/**
 * @deprecated use new `Combobox` and its sub-components instead
 */ const LegacyCombobox = Combobox, /**
   * @deprecated use new `Combobox` and its sub-components instead
   */ LegacyComboboxOptionText = ComboboxOptionText, /**
   * @deprecated use new `Combobox` and its sub-components instead
   */ useLegacyComboboxContext = useComboboxContext, /**
   * @deprecated use new `Combobox` and its sub-components instead
   */ useLegacyComboboxOptionContext = useComboboxOptionContext;
/**
 * @deprecated use new `BasicCombobox`
 */ const LegacyBasicCombobox = deprecatedComponent({
    displayName: 'LegacyBasicCombobox',
    root: LegacyBasicCombobox$1,
    description: 'Legacy ReachUI BasicCombobox is Deprecated. Migrate to new BasicCombobox'
}) /* PLOP_COMPONENT_EXPORT_IN_INDEX */ ;

export { LegacyBasicCombobox, LegacyCombobox, LegacyComboboxOptionText, useLegacyComboboxContext, useLegacyComboboxOptionContext };
